// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"130":"1f08ea51e55f12ec4547","131":"562587c38cd28cdc4ade","192":"f6968e95c24366a2a7e7","228":"098f9d9e1df3bae52b8a"}[chunkId] + ".chunk.css";
};